import React from "react"
import { useLocation } from "react-router-dom"
import { useCookies } from "react-cookie"
import { useDispatch } from "react-redux"
import { logoutAction } from "../../../redux/slices/authSlice"

import CustomLink from "../CustomLink"
import { useIntl } from "react-intl"

const Navbar = () => {
  // eslint-disable-next-line no-unused-vars
  const [_, __, removeCookie] = useCookies(["token"])
  const { pathname } = useLocation();

  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const handleLogout = () => {
    removeCookie("token", {
      path: "/",
    })
    dispatch(logoutAction())
  }

  const menuItems = []

  menuItems.push(
    {
      name: formatMessage({ id: "navbar.settings" }),
      type: "link",
      to: "/settings",
    },
    {
      name: formatMessage({ id: "navbar.logout" }),
      type: "button",
      onClick: handleLogout,
    },
  )

  return (
    <div className="navbar">
      <div className="navbar__wrapper">
        <div className="navbar__menus">
          <CustomLink
            to={"/api-keys"}
            active={pathname === "/api-keys"}
          >
            API Keys
          </CustomLink>
          <CustomLink
            to={"/api-requests"}
            active={pathname === "/api-requests"}
          >
            API Requests
          </CustomLink>
        </div>
      </div>
    </div>
  )
}

export default Navbar
